// VND currency + Vietnamese date formatting helpers.

const vnd = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND', maximumFractionDigits: 0 });
const num = new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 0 });

// "120.000 ₫"
export function formatVND(amount) {
    return vnd.format(Number(amount) || 0);
}

// "120.000" (no currency symbol — for tables/inputs)
export function formatNumber(amount) {
    return num.format(Number(amount) || 0);
}

// "17/06/2026" or "17/06/2026 14:30"
export function formatDate(value, withTime = false) {
    if (!value) return '—';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '—';
    const date = d.toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' });
    if (!withTime) return date;
    const time = d.toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' });
    return `${date} ${time}`;
}

// "2026-06-17" (local) — for the cash endpoint's ?date= and <input type=date>.
export function toYmd(value = new Date()) {
    const d = new Date(value);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
